import React from 'react';
import {
  TRUSTPILOT_WIDGET_COMPONENT, TRUSTPILOT_WIDGET_SCRIPT_TAG_ID, TRUSTPILOT_WIDGET_SCRIPT_TAG_SRC,
} from '../constants';
import type { TrustpilotWidgetProps } from './types';

const TrustpilotWidget: React.FC<TrustpilotWidgetProps> = ({
  type,
  theme = 'light',
  clickable = true,
  ...rest
}) => {
  const ref = React.createRef<HTMLDivElement>();

  const scriptTagId = TRUSTPILOT_WIDGET_SCRIPT_TAG_ID[type];
  const TrustBox = TRUSTPILOT_WIDGET_COMPONENT[type];

  React.useEffect(() => {
    // load script tag once that automatically swaps our content with iframe
    if (window && !window.document.getElementById(scriptTagId)) {
      const script = window.document.createElement('script');
      script.id = scriptTagId;
      script.src = TRUSTPILOT_WIDGET_SCRIPT_TAG_SRC;
      window.document.head.appendChild(script);
    } else if (window.Trustpilot && ref.current) {
      // if script has been loaded before: call their API manually to redraw box
      window.Trustpilot.loadFromElement(ref.current);
    }
  });

  return (
    <TrustBox
      ref={ref}
      theme={theme}
      clickable={clickable}
      {...rest}
    />
  );
};

export default TrustpilotWidget;
